import { useQuery } from 'react-query';
import { POST } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';

export const ErrorPages = ({ journeyGuid, lngCode, useMock, clientStateData }) => {

    const baseApi = `${lngCode}`;
    const clientStateDataUpdate = useClientStateDataUpdate();

    return {
        useErrorPagesQuery(processGUID, { skip }, onError) {
            return useQuery(['active-query', 'validateProcess', lngCode, processGUID],
                ({ queryKey }) => getErrorPages(...queryKey.slice(3)),
                {
                    enabled: !skip, onError: onError
                }
            );
        }
    }

    async function getErrorPages(processGUID) {
        if (useMock) {
            return Promise.resolve(() => {
                return {
                    isValid: true,
                    clientStateData: {}
                }
            })
        }
        const params = {
            identity: journeyGuid,
            processGuid: processGUID,
            lngCode: lngCode,
            clientStateData
        }

        return POST(`${baseApi}/errorpages/validateprocess`, params)
            .then(async (response) => {
                if (response.clientStateData) { clientStateDataUpdate(response.clientStateData) }
            })

    }
}